export default [
    {
        path: '/consult',
        component: () => import('../components/pages/consult/consult.vue') ,
        meta: {
            title: '有偿资讯'
        }
    }

]